import { StripeSync } from "@/components/admin/StripeSync";

export default function StripeSyncPage() {
  return <StripeSync />;
}
